(function () {

    angular
        .module('stControls', [])
        .directive('stOnEnter', stOnEnter);

    function stOnEnter() {
        return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                var selector = attrs.stOnEnter;
                elem.on('keydown',
                    function (event) {
                        if (event.keyCode !== 13)
                            return true;
                        scope.$apply(selector);
                        return false;
                    });
            }
        };
    }

})();